<template>
  <div class="analyse-container animate__animated animate__fadeIn">
    <div class="page-content" style="width:339px">
      <el-input placeholder="输入关键字进行过滤" size="mini" v-model="filterText" clearable></el-input>
      <el-tree ref="tree" style="margin-top:10px" class="filter-tree" :filter-node-method="filterNode" :data="treeData"
        node-key="id" highlight-current default-expand-all @node-click="handleNodeClick" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <!-- 如果有子节点，显示files.png（打开的文件夹图标） -->
          <img v-if="data.children" :src="require('@/assets/file-s-0.png')" alt="files" class="tree-icon" />
          <!-- 如果没有子节点，显示file.png（普通文件夹图标） -->
          <img v-else :src="require('@/assets/file-b-0.png')" alt="file" class="tree-icon" />
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div class="page-content" style="flex:1;margin-left:0;">
      <div class="border-bottom" style="margin-top:0;">
        <!-- 顶部搜索框 -->
        <div>
          <el-form :inline="true" :model="queryParams" class="demo-form-inline">
            <el-form-item label="波形图名称">
              <el-input v-model="queryParams.waveFormName" placeholder="请输入波形图名称进行查询" class="form-item-width"
                clearable></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select clearable v-model="queryParams.type" placeholder="请选择类型">
                <el-option v-for="item in systemModelList" :key="item.dictValue" :label="item.dictLabel"
                  :value="item.dictValue"></el-option>
              </el-select>
            </el-form-item>
            <div class="btn-boxs">
              <div>
                <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                  @click="batchDelete">批量删除</el-button>
                <el-button icon="el-icon-download" type="success" @click="downloadPlugIn">软件下载</el-button>
          
              </div>
              <div>
                <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
                <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
              </div>
            </div>
          </el-form>
        </div>
      </div>

      <div class="margin-top" style="margin-bottom:0;margin-top:15px">
        <el-table :data="tableData" v-loading="tableLoading" border row-key="deptId" default-expand-all
          :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
          :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
          @selection-change="handleSelectionChange">
          <!-- 多选 -->
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
          <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
            show-overflow-tooltip :width="tab.width">
            <template slot-scope="scope">
              <span v-if="tab.code === 'lineType' && scope.row.lineType !== null">{{ scope.row.lineType === '0' ? '单线' :
                scope.row.lineType === '1' ? '上行' : '下行' }}</span>
              <span v-else-if="tab.code === 'waveFormTime'">
                <i class="el-icon-time"></i>
                <span style="margin-left:5px">{{ scope.row.waveFormTime }}</span>
              </span>
              <span v-else-if="tab.code === 'type'">{{ scope.row.type + 'C' }}</span>

              <span v-else>{{ scope.row[tab.code] }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="openOscillogram(scope.row)">下载文件</el-button>

              <el-button type="text" @click="updateData(scope.row)">修改</el-button>

              <el-button style="color:red" type="text" @click="deleteData(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
            @pagination="onChangePages" />
        </div>
      </div>
    </div>
    <!-- 修改波形图信息 -->
    <el-dialog title="修改" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="线路" prop="circuitId">
          <el-select clearable v-model="form.circuitId" placeholder="请选择线路" @change="circuitChange">
            <el-option v-for="item in circuitList" :key="item.circuitId" :label="item.circuitName"
              :value="item.circuitId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行别" prop="lineType">
          <el-select clearable v-model="form.lineType" placeholder="请选择行别" >
            <el-option v-for="item in lineTypeList" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue"></el-option>
          </el-select>
        </el-form-item>
   
        <el-form-item label="波形图时间" prop="waveFormTime">
          <el-date-picker v-model="form.waveFormTime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime" placeholder="选择波形图时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="波形图名称" prop="waveFormName">
          <el-input type="textarea" v-model="form.waveFormName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from "@http";

import Pagination from "@/components/Pagination";
import { getWaveFormList,waveFormById,updeteWaveForm,deleteWaveForm,getCircuitTree} from "@/api/document-service/oscillogram.js";
import { getComponentAll } from "@/api/data-service/unit.js";
import { getStationAll } from "@/api/data-service/station.js";
import { getCircuitAll } from "@/api/data-service/line.js";
import { getSystemModel } from "@/api/admin-service/dictDataType.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      dialogFormVisible: false,
      form: {
        circuitId: '',
        lineType: '',
        waveFormTime: "",
        waveFormName: "",
      },
      rules: {
        circuitId: [{ required: true, message: "请选择线路", trigger: "blur" }],
        lineType: [{ required: true, message: "请选择行别", trigger: "blur" }],
        stationId: [{ required: true, message: "请选择区站", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        waveFormTime: [{ required: true, message: "请选择波形图时间", trigger: "blur" }],
        waveFormName: [{ required: true, message: "请输入波形图名称", trigger: "blur" }],
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "线路", code: "circuitName", width: "" },
        { name: "行别", code: "lineType", width: "" },
        { name: "类型", code: "type", width: "" },
        { name: "波形图名称", code: "waveFormName", width: "" },
        { name: "波形图路径", code: "path", width: "" },
        { name: "波形图时间", code: "waveFormTime", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        circuitId: "",
        // stationId: "",
        waveFormName: "",
        type: ""
      },

      treeData: [],
      multipleSelection: [],
      filterText: "", // 过滤树的值,
      circuitList: [],
      lineTypeList: [],
      systemModelList: []
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {
    this.onGetDataList();
    this.getCircuitTree();
    this.queryCircuitList();
    this.getSystemModel();
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updeteWaveForm(this.form).then(res => {
            if (res.data || res.code === '200') {
              this.$message.success('修改成功！' || res?.msg)
              this.onGetDataList()
              this.dialogFormVisible = false
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.dialogFormVisible = false
      this.$refs[formName].resetFields();
    },
 
    circuitChange(newValue) {

      this.form.lineType = "";
      this.form.startStationId = "";
      this.form.endStationId = "";
      this.form.startStationSign = "";
      this.form.endStationSign = "";
      this.form.classify = "";
      // this.queryParams.circuitId = newValue;
      this.circuitList.forEach(item => {
        if (item.circuitId === newValue) {
          if (item.classify === '1') {
            this.form.classify = '1'
          } else {
            this.form.classify = '0'

          }

          if (item.type === "0") {
            // 说明是单线
            this.lineTypeList = [
              {
                dictLabel: "单线",
                dictValue: "0"
              }
            ];
          } else {
            this.lineTypeList = [
              {
                dictLabel: "上行",
                dictValue: "1"
              },
              {
                dictLabel: "下行",
                dictValue: "2"
              }
            ];
          }
        }

      });
    },
    updateData(row) {
      this.dialogFormVisible = true
      waveFormById({ id: row.waveFormId }).then(res => {
        if (res.code === '200') {
          const { circuitId, lineType } = res.data
          this.circuitList.forEach(item => {
            if (item.circuitId === circuitId) {
              if (item.type === "0") {
                // 说明是单线
                this.lineTypeList = [
                  {
                    dictLabel: "单线",
                    dictValue: "0"
                  }
                ];
              } else {
                this.lineTypeList = [
                  {
                    dictLabel: "上行",
                    dictValue: "1"
                  },
                  {
                    dictLabel: "下行",
                    dictValue: "2"
                  }
                ];
              }
              this.form.lineType = lineType
            }
          })
          Object.assign(this.form, res?.data)
        }

      })
    },
    getSystemModel() {
      getSystemModel({ type: "sys_model_type" }).then(res => {
        this.systemModelList = res?.data || [];
      });
    },
    // 波形图对比
    oscillogramCompare() {
      if (
        this.multipleSelection.length <= 1 ||
        this.multipleSelection.length > 3
      ) {
        this.$message.error("只能选择2个或者3个波形图进行对比！");
        return;
      }
      const arr = this.multipleSelection.map(item => item?.path);
      const formData = new FormData();
      formData.append("files", arr); // 将 filePath 作为参数 id 添加到 formData 中
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" } // 这个根据你的接口要求设置
      };
      http
        .post(
          `http://localhost:9999/api/waveForm/openHistory`,
          formData,
          config
        )
        .then(res => {
          console.log("Response:", res);
          // 根据响应进行相应处理
        })
        .catch(error => {
          console.error("Error:", error);
        });
    },
    openOscillogram(row) {
      const domainName = process.env.VUE_APP_SOURCE1;
      const link = document.createElement("a");
      link.href = domainName + row.path; // 设置文件的下载链接
      link.target = "_blank"; // 可以选择在新标签页中打开，通常下载操作不需要
      link.rel = "noopener noreferrer"; // 安全性增强
      // 设置文件下载
      link.download = row.path; // 提供下载时显示的文件名
      // 模拟点击事件，开始下载
      link.click();
    },
    downloadPlugIn() {
      const domainName = process.env.VUE_APP_SOURCE1;
      const link = document.createElement("a");
      link.href = domainName + "/软件/波形软件.zip"; // 设置文件的下载链接
      link.target = "_blank"; // 可以选择在新标签页中打开，通常下载操作不需要
      link.rel = "noopener noreferrer"; // 安全性增强
      // 设置文件下载
      link.download = "波形软件.zip"; // 提供下载时显示的文件名
      // 模拟点击事件，开始下载
      link.click();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 waveFormId 组成的数组
          const ids = (this.multipleSelection || []).map(
            item => item.waveFormId
          );
          deleteWaveForm({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(node) {
      // 每次点击之前清空 两个id
      this.queryParams.circuitId = "";
      this.queryParams.stationId = "";
      if (node.parentId === "0") {
        // 代表点击的是线路   查询下面的区站
        getStationAll({
          circuitId: node.id,
          stationName: "" //区站名称
        }).then(res => {
          node.children =
            res?.data.map(item => {
              return {
                ...item,
                value: item.id,
                label: item.stationName
              };
            }) || [];
        });
        this.queryParams.circuitId = node.id;
      } else {
        // 代表点击的是区站
        this.queryParams.stationId = node.stationId;
      }
      this.onGetDataList();
    },
    getCircuitTree() {
      getCircuitTree({}).then(res => {
        this.treeData = res?.data || [];
      });
    },
    queryComponentList() {
      getComponentAll({
        orderByColumn: "",
        isAsc: "",
        componentName: "",
        orderBy: "",
        ...this.pageParams
      }).then(res => {
        this.componentList = res?.data || [];
      });
    },

    queryCircuitList() {
      getCircuitAll({
        orderByColumn: "",
        isAsc: "",
        circuitName: "", //线路名称
        orderBy: "",
        ...this.pageParams
      }).then(res => {
        this.circuitList = res?.data || [];
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          deleteWaveForm({ ids: [row.waveFormId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 查
    onGetDataList() {
      this.tableLoading = true;
      getWaveFormList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records;
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handlewaveFormAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },

    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1;
      this.pageParams.pageSize = 10;
      Object.keys(this.queryParams).forEach(key => {
        this.queryParams[key] = ""; // 你可以根据需要调整重置的值（例如：'' 或者 null）
      });
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.custom-tree-node {
  display: flex;
  width: 100%;
  align-items: center;

  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}

::v-deep .el-tree-node__children {
  max-height: 400px;
  overflow: auto;
}
</style>
